import * as yup from 'yup';

import { clientEnvVarSchema, clientEnvVars } from './validateEnvVariables';

type AppClientConfig = yup.InferType<typeof clientEnvVarSchema>;

export const appClientConfig: AppClientConfig = clientEnvVarSchema.cast(clientEnvVars, {
  assert: false,
});
